import { render, staticRenderFns } from "./StokKarlilikRaporu.vue?vue&type=template&id=63231006&"
import script from "./StokKarlilikRaporu.vue?vue&type=script&lang=js&"
export * from "./StokKarlilikRaporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports